import { unstable_serialize } from "swr";
import query from "utils/query";
import Config from "components/config";
import ParkDetails from "components/parks/park-details";

// used in get static props
import PARK_QUERY from "queries/park";

export default function Park({ fallback }) {
  return (
    <Config fallback={fallback}>
      <ParkDetails />
    </Config>
  );
}

export async function getStaticPaths() {
  // We'll build some of the top parks
  const parks = [
    "disneyland-park",
    "disney-california-adventure-park",
    "disney-s-magic-kingdom",
    "epcot",
    "disney-s-animal-kingdom",
    "disney-s-hollywood-studios",
    "universal-studios-florida",
    "universal-s-islands-of-adventure",
    "universal-s-volcano-bay",
    "universal-studios-hollywood",
    "universal-s-epic-universe",
    "six-flags-magic-mountain",
    "sea-world-san-diego",
    "sea-world-orlando",
    "sea-world-san-antonio",
    "busch-gardens-tampa-bay",
    "busch-gardens-williamsburg",
    "legoland-california",
    "legoland-florida",
    "peppa-pig-theme-park",
    "knott-s-berry-farm",
    "cedar-point",
    "canada-s-wonderland",
  ];

  const paths = parks.map((park) => ({
    params: { park },
  }));

  return { paths, fallback: "blocking" };
}

export async function getStaticProps({ params }) {
  const fallback = {};

  const variables = {
    slug: params.park,
  };

  const data = await Promise.all([query(PARK_QUERY, variables)]);

  fallback[[unstable_serialize([PARK_QUERY, variables])]] = data[0];

  return {
    props: {
      fallback,
    },
  };
}
